/**
 * Smoosh Family Kit — JavaScript
 * Version: 1.0
 *
 * Forked from product.starter-kit.js (Layer 2 only).
 * Layer 1 (global cart maintenance) is shared — loaded separately via product.starter-kit.js.
 *
 * Key differences from starter kit:
 *   - Step 1: Multi-scrubber selection (1–4) with per-color qty controls
 *   - Dynamic pricing: plan card prices update based on scrubber count
 *   - ATC builds line items for N scrubbers (possibly multiple of the same color)
 *   - Uses FamilyKitData instead of StarterKitData
 *   - Bundle key prefix: 'smoosh-family-kit'
 */

(function () {
  'use strict';

  if (window._fkLayer2Loaded) return;
  window._fkLayer2Loaded = true;

  const REQUIRED_SOAPS    = 3;
  const BUNDLE_KEY_PREFIX = 'smoosh-family-kit';

  // ─── DOM ──────────────────────────────────────────────────────────────────
  const pdp = document.querySelector('.family-kit-pdp');
  if (!pdp) return;

  const data = window.FamilyKitData || {};
  const cms  = data.cms || {};

  const MAX_SCRUBBERS       = data.maxScrubbers || 4;
  const SCRUBBER_PRICE      = data.scrubberPriceCents  || 3900;  // cents – per scrubber at full price
  const SOAP_PACK_PRICE     = data.soapPackPriceCents  || 3900;  // cents – fixed 3-soap-pack price
  const DISCOUNT_PERCENT    = data.discountPercent     || 50;    // CMS-controlled discount %
  const DISCOUNT_CODES      = data.discountCodes || {};         // { 1: 'CODE', 2: 'CODE', ... }

  const scrubberTiles       = pdp.querySelectorAll('.fk-scrubber-tile');
  const scrubberCountLabel  = pdp.querySelector('#fk-scrubber-count-label');
  const soapTiles           = pdp.querySelectorAll('.sk-soap-tile');
  const soapProgressSteps   = pdp.querySelectorAll('.sk-soap-progress__step');
  const soapCountLabel      = pdp.querySelector('#sk-soap-count-label');
  const planCards           = pdp.querySelectorAll('.sk-plan-card');
  const atcBtn              = pdp.querySelector('#sk-atc-btn');
  const atcBtnText          = pdp.querySelector('#sk-atc-btn-text');
  const atcNote             = pdp.querySelector('#sk-atc-note');
  const atcError            = pdp.querySelector('#sk-atc-error');
  const mainImage           = pdp.querySelector('#sk-main-image');
  const thumbTrack          = pdp.querySelector('#sk-thumb-track');
  const thumbBar            = pdp.querySelector('#sk-thumb-bar');
  const thumbBtns           = pdp.querySelectorAll('.starter-kit-pdp__thumb');
  const onetimeCons         = pdp.querySelector('.sk-perks--cons');

  // Dynamic price elements in plan cards
  const subFullEl           = pdp.querySelector('#fk-sub-full');
  const subSaleEl           = pdp.querySelector('#fk-sub-sale');
  const otPriceEl           = pdp.querySelector('#fk-ot-price');

  // ─── State ────────────────────────────────────────────────────────────────
  // scrubberQty: { variantId → count } (e.g., { "123": 2, "456": 1 })
  const state = {
    mode:        'subscribe',
    scrubberQty: {},
    soapSlots:   [null, null, null]
  };

  // ─── Helpers ──────────────────────────────────────────────────────────────
  function totalScrubbers() {
    return Object.values(state.scrubberQty).reduce((sum, n) => sum + n, 0);
  }

  function soapCount() {
    return state.soapSlots.filter(Boolean).length;
  }

  function countForSoapVariant(vid) {
    return state.soapSlots.filter(s => s && s.variantId === vid).length;
  }

  function isComplete() {
    return totalScrubbers() >= 1 && soapCount() === REQUIRED_SOAPS;
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function showAtcError(msg) {
    if (atcError) { atcError.textContent = msg; atcError.hidden = false; }
  }

  function clearAtcError() {
    if (atcError) { atcError.textContent = ''; atcError.hidden = true; }
  }

  // ─── Dynamic pricing ─────────────────────────────────────────────────────
  // Full price = soap pack (fixed) + scrubber price × count
  // Sale price = full price × (1 - discount%)
  // One-time   = full price (no discount)
  function updatePrices() {
    const count = Math.max(totalScrubbers(), 1); // show at least 1-scrubber price

    const fullTotal = SOAP_PACK_PRICE + (SCRUBBER_PRICE * count);
    const saleTotal = Math.round(fullTotal * (1 - DISCOUNT_PERCENT / 100));
    const otTotal   = fullTotal;

    if (subFullEl) subFullEl.textContent = formatPrice(fullTotal);
    if (subSaleEl) subSaleEl.textContent = formatPrice(saleTotal);
    if (otPriceEl) otPriceEl.textContent = formatPrice(otTotal);
  }

  // ─── Render ───────────────────────────────────────────────────────────────
  function render() {
    clearAtcError();
    updatePrices();

    const scrubCount = totalScrubbers();

    // Scrubber count label
    if (scrubberCountLabel) {
      scrubberCountLabel.textContent = scrubCount === 0
        ? '0 selected'
        : scrubCount === 1
          ? '1 scrubber'
          : `${scrubCount} scrubbers`;
    }

    // Scrubber tiles
    scrubberTiles.forEach(tile => {
      const vid   = tile.dataset.variantId;
      const count = state.scrubberQty[vid] || 0;
      const addBtn  = tile.querySelector('.fk-scrubber-tile__add-btn');
      const counter = tile.querySelector('.fk-scrubber-tile__counter');
      const qtyEl   = tile.querySelector('.fk-scrubber-tile__qty');
      const incrBtn = tile.querySelector('.fk-scrubber-tile__increment');

      tile.classList.toggle('is-selected', count > 0);

      if (count > 0) {
        addBtn.hidden  = true;
        counter.hidden = false;
        if (qtyEl) qtyEl.textContent = count;
      } else {
        addBtn.hidden  = false;
        counter.hidden = true;
      }

      if (incrBtn) incrBtn.disabled = scrubCount >= MAX_SCRUBBERS;
      if (addBtn)  addBtn.disabled  = scrubCount >= MAX_SCRUBBERS || tile.classList.contains('fk-scrubber-tile--soldout');
    });

    // Soap count
    if (soapCountLabel) soapCountLabel.textContent = `${soapCount()} of ${REQUIRED_SOAPS} selected`;

    // Soap progress dots
    const filled = soapCount();
    soapProgressSteps.forEach((stepEl, i) => {
      stepEl.classList.toggle('sk-soap-progress__step--filled', i < filled);
      stepEl.classList.toggle('sk-soap-progress__step--next',   i === filled && filled < REQUIRED_SOAPS);
    });

    // Soap tiles
    soapTiles.forEach(tile => {
      const vid    = tile.dataset.variantId;
      const count  = countForSoapVariant(vid);
      const addBtn = tile.querySelector('.sk-soap-tile__add-btn');
      const counter = tile.querySelector('.sk-soap-tile__counter');
      const qtyEl  = tile.querySelector('.sk-soap-tile__qty');
      const incrBtn = tile.querySelector('.sk-soap-tile__increment');

      tile.classList.toggle('is-selected', count > 0);

      if (count > 0) {
        addBtn.hidden  = true;
        counter.hidden = false;
        if (qtyEl) qtyEl.textContent = count;
      } else {
        addBtn.hidden  = false;
        counter.hidden = true;
      }

      if (incrBtn) incrBtn.disabled = soapCount() >= REQUIRED_SOAPS;
      if (addBtn)  addBtn.disabled  = (soapCount() >= REQUIRED_SOAPS) || tile.classList.contains('sk-soap-tile--soldout');
    });

    // One-time cons
    if (onetimeCons) onetimeCons.hidden = state.mode !== 'onetime';

    // ATC button state
    const complete = isComplete();
    atcBtn.disabled = !complete;
    atcBtn.setAttribute('aria-disabled', String(!complete));

    if (atcBtnText) {
      if (!complete) {
        atcBtnText.textContent = cms.atcIncomplete || 'Complete your kit to continue';
      } else {
        const count = totalScrubbers();
        const fullTotal = SOAP_PACK_PRICE + (SCRUBBER_PRICE * count);
        if (state.mode === 'subscribe') {
          const label = cms.atcSubLabel || 'ADD TO BAG';
          const full  = formatPrice(fullTotal);
          const sale  = formatPrice(Math.round(fullTotal * (1 - DISCOUNT_PERCENT / 100)));
          atcBtnText.innerHTML = `${label}&nbsp;|&nbsp;<s>${full}</s>&nbsp;${sale}`;
        } else {
          const label = cms.atcOtLabel || 'ADD TO BAG';
          const price = formatPrice(fullTotal);
          atcBtnText.textContent = `${label} | ${price}`;
        }
      }
    }

    if (atcNote) {
      atcNote.innerHTML = (complete && state.mode === 'subscribe')
        ? (cms.atcSubNote || '')
        : '';
    }
  }

  // ─── Plan selection ───────────────────────────────────────────────────────
  planCards.forEach(card => {
    card.addEventListener('click', () => {
      const mode = card.dataset.mode;
      if (!mode || state.mode === mode) return;
      state.mode = mode;
      planCards.forEach(c => {
        c.classList.toggle('is-selected', c.dataset.mode === mode);
        const radio = c.querySelector('input[type="radio"]');
        if (radio) radio.checked = c.dataset.mode === mode;
      });
      render();
    });
  });

  // ─── Scrubber tile interactions ───────────────────────────────────────────
  scrubberTiles.forEach(tile => {
    const addBtn  = tile.querySelector('.fk-scrubber-tile__add-btn');
    const decrBtn = tile.querySelector('.fk-scrubber-tile__decrement');
    const incrBtn = tile.querySelector('.fk-scrubber-tile__increment');
    const imgWrap = tile.querySelector('.fk-scrubber-tile__image-wrap');
    const vid     = tile.dataset.variantId;

    function addScrubber() {
      if (tile.classList.contains('fk-scrubber-tile--soldout')) return;
      if (totalScrubbers() >= MAX_SCRUBBERS) return;
      state.scrubberQty[vid] = (state.scrubberQty[vid] || 0) + 1;
      // Update main image to this color
      if (mainImage && tile.dataset.fullres) mainImage.src = tile.dataset.fullres;
      render();
    }

    function removeScrubber() {
      if (!state.scrubberQty[vid]) return;
      state.scrubberQty[vid] -= 1;
      if (state.scrubberQty[vid] <= 0) delete state.scrubberQty[vid];
      render();
    }

    if (addBtn)  addBtn.addEventListener('click',  e => { e.stopPropagation(); addScrubber(); });
    if (incrBtn) incrBtn.addEventListener('click', e => { e.stopPropagation(); addScrubber(); });
    if (decrBtn) decrBtn.addEventListener('click', e => { e.stopPropagation(); removeScrubber(); });

    if (imgWrap) {
      imgWrap.addEventListener('click', e => {
        if (e.target.closest('.fk-scrubber-tile__controls')) return;
        if (tile.classList.contains('fk-scrubber-tile--soldout')) return;
        if ((state.scrubberQty[vid] || 0) > 0) return; // already has qty, use +/- buttons
        addScrubber();
      });
    }
  });

  // ─── Soap tile interactions (identical to starter kit) ────────────────────
  soapTiles.forEach(tile => {
    const addBtn  = tile.querySelector('.sk-soap-tile__add-btn');
    const decrBtn = tile.querySelector('.sk-soap-tile__decrement');
    const incrBtn = tile.querySelector('.sk-soap-tile__increment');
    const imgWrap = tile.querySelector('.sk-soap-tile__image-wrap');

    function getSoapData() {
      return {
        variantId:     tile.dataset.variantId,
        productId:     tile.dataset.productId,
        sellingPlanId: tile.dataset.sellingPlanId || '',
        title:         tile.dataset.productTitle,
        price:         parseInt(tile.dataset.productPrice, 10) || 0,
        image:         tile.dataset.productImage
      };
    }

    function addSoap() {
      if (tile.classList.contains('sk-soap-tile--soldout')) return;
      if (soapCount() >= REQUIRED_SOAPS) return;
      const emptyIdx = state.soapSlots.findIndex(s => s === null);
      if (emptyIdx === -1) return;
      state.soapSlots[emptyIdx] = getSoapData();
      render();
    }

    function removeSoap() {
      const vid = tile.dataset.variantId;
      for (let i = state.soapSlots.length - 1; i >= 0; i--) {
        if (state.soapSlots[i] && state.soapSlots[i].variantId === vid) {
          state.soapSlots[i] = null;
          break;
        }
      }
      const filledSlots = state.soapSlots.filter(Boolean);
      while (filledSlots.length < REQUIRED_SOAPS) filledSlots.push(null);
      state.soapSlots = filledSlots;
      render();
    }

    if (addBtn)  addBtn.addEventListener('click',  e => { e.stopPropagation(); addSoap(); });
    if (incrBtn) incrBtn.addEventListener('click', e => { e.stopPropagation(); addSoap(); });
    if (decrBtn) decrBtn.addEventListener('click', e => { e.stopPropagation(); removeSoap(); });

    if (imgWrap) {
      imgWrap.addEventListener('click', e => {
        if (e.target.closest('.sk-soap-tile__controls')) return;
        if (tile.classList.contains('sk-soap-tile--soldout')) return;
        if (countForSoapVariant(tile.dataset.variantId) > 0) return;
        addSoap();
      });
    }
  });

  // ─── Thumbnail gallery ────────────────────────────────────────────────────
  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (mainImage && btn.dataset.src) mainImage.src = btn.dataset.src;
      updateThumbProgress();
    });
  });

  function updateThumbProgress() {
    if (!thumbTrack || !thumbBar) return;
    const { scrollLeft, scrollWidth, clientWidth } = thumbTrack;
    const maxScroll  = scrollWidth - clientWidth;
    const pct        = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
    const visibleFrac = clientWidth / scrollWidth;
    thumbBar.style.width = `${visibleFrac * 100}%`;
    thumbBar.style.left  = `${pct * (1 - visibleFrac)}%`;
  }

  if (thumbTrack) {
    thumbTrack.addEventListener('scroll', updateThumbProgress, { passive: true });
    updateThumbProgress();
    if (thumbBar) {
      const hidePb = () => {
        const { scrollWidth, clientWidth } = thumbTrack;
        const pbWrap = pdp.querySelector('.starter-kit-pdp__thumb-progress');
        if (pbWrap) pbWrap.style.display = scrollWidth <= clientWidth ? 'none' : '';
      };
      hidePb();
      window.addEventListener('resize', hidePb);
    }
  }

  // ─── Add to cart ──────────────────────────────────────────────────────────
  if (atcBtn.dataset.fkBound) {
    console.warn('[FamilyKit] ATC already bound — skipping duplicate listener');
  } else {
    atcBtn.dataset.fkBound = '1';

    let _atcBusy = false;

    atcBtn.addEventListener('click', async () => {
      if (_atcBusy) return;
      if (!isComplete()) return;
      _atcBusy = true;

      const { skScrubberVariantMap } = data;

      atcBtn.disabled = true;
      atcBtnText.textContent = 'Adding…';

      const bundleKey = `${BUNDLE_KEY_PREFIX}-${Date.now()}`;

      try {
        const items = [];

        // Build scrubber line items
        Object.entries(state.scrubberQty).forEach(([vid, qty]) => {
          if (qty <= 0) return;

          if (state.mode === 'subscribe') {
            // Resolve SK variant by color title
            const tile = pdp.querySelector(`.fk-scrubber-tile[data-variant-id="${vid}"]`);
            const colorTitle = tile ? tile.dataset.variantTitle : '';
            const skVid = skScrubberVariantMap && skScrubberVariantMap[colorTitle];

            if (!skVid) {
              throw new Error(`Could not resolve subscription scrubber variant for "${colorTitle}".`);
            }

            items.push({
              id:         skVid,
              quantity:   qty,
              properties: { '_bundle_key': bundleKey, '_bundle_label': 'scrubber', '_bundle_mode': 'subscribe' }
            });
          } else {
            items.push({
              id:         vid,
              quantity:   qty,
              properties: { '_bundle_key': bundleKey, '_bundle_label': 'scrubber', '_bundle_mode': 'onetime' }
            });
          }
        });

        // Build soap line items
        if (state.mode === 'subscribe') {
          const soapMap = {};
          state.soapSlots.forEach(s => {
            if (!s) return;
            if (!soapMap[s.variantId]) {
              soapMap[s.variantId] = { qty: 0, sellingPlanId: parseInt(s.sellingPlanId, 10) };
            }
            soapMap[s.variantId].qty += 1;
          });

          // Validate selling plans
          const missingSoap = state.soapSlots.find(s => s && !parseInt(s.sellingPlanId, 10));
          if (missingSoap) {
            showAtcError('Subscription setup is incomplete for ' + (missingSoap.title || 'a soap') + '. Please refresh and try again.');
            _atcBusy = false;
            render();
            return;
          }

          Object.entries(soapMap).forEach(([id, { qty, sellingPlanId }]) => {
            items.push({
              id,
              quantity:      qty,
              selling_plan:  sellingPlanId,
              properties:    { '_bundle_key': bundleKey, '_bundle_label': 'soap', '_bundle_mode': 'subscribe' }
            });
          });
        } else {
          const soapQtyMap = {};
          state.soapSlots.forEach(s => {
            if (s) soapQtyMap[s.variantId] = (soapQtyMap[s.variantId] || 0) + 1;
          });
          Object.entries(soapQtyMap).forEach(([id, qty]) => {
            items.push({
              id,
              quantity:   qty,
              properties: { '_bundle_key': bundleKey, '_bundle_label': 'soap', '_bundle_mode': 'onetime' }
            });
          });
        }

        // POST to cart
        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);

        // Apply discount code for subscribe mode (mapped by scrubber count)
        if (state.mode === 'subscribe') {
          const discountCode = DISCOUNT_CODES[totalScrubbers()];
          if (discountCode) {
            try {
              await fetch('/discount/' + encodeURIComponent(discountCode), { method: 'GET' });
            } catch (e) {
              console.warn('[FamilyKit] Discount apply failed:', e);
            }
          }
        }

        // Re-render cart drawer
        const sections = await fetch('/cart?sections=cart-drawer,cart-icon-bubble')
          .then(r => r.json())
          .catch(() => null);

        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.renderContents === 'function' && sections) {
          if (window._skSetSuppressed) window._skSetSuppressed(true);
          drawerEl.classList.remove('is-empty');
          drawerEl.renderContents({ sections });
          setTimeout(() => {
            if (window._skInjectKitCard) window._skInjectKitCard();
            setTimeout(() => {
              if (window._skSetSuppressed) window._skSetSuppressed(false);
              _atcBusy = false;
            }, 1000);
          }, 250);
        } else {
          window.location.href = '/cart';
        }

        // Reset selections
        state.scrubberQty = {};
        state.soapSlots   = [null, null, null];
        render();
      } catch (err) {
        console.error('[FamilyKit] ATC error:', err);
        showAtcError(err.message || 'Something went wrong adding your kit. Please try again.');
        _atcBusy = false;
        render();
      }
    });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  render();
})();